import PropTypes from "prop-types"
import React, { useEffect } from "react"
import withRouter from "./Common/withRouter"
import { useDispatch } from "react-redux"
import NonAuthHeader from "./Lystface/Common/NonAuthHeader"

import {
  userForgetPasswordReset,
  registerUserReset,
  LoginUserReset,
} from "../store/actions"
import Footer from "./Lystface/Common/Footer"

const NonAuthLayout = props => {

  const dispatch = useDispatch()
  if (!props.router.location.pathname.startsWith("/signup")) {
    dispatch(registerUserReset())

  }
  return (

    <div>
      <NonAuthHeader isLogin={props.router.location.pathname === "/login" || props.router.location.pathname === "/forgot-password"} />
      {props.children}
      <Footer />

    </div>
  )
}

NonAuthLayout.propTypes = {
  children: PropTypes.any,
  location: PropTypes.object,
}

export default withRouter(NonAuthLayout)
